import { Formik, FormikHelpers } from 'formik';

import { notifyError } from '@/portainer/services/notifications';

import { InnerForm } from './InnerForm';
import { AlertSettingsFormValues, AlertSettingsRow } from './types';
import { useUpdateAlertSettings } from './useAlertSettings';
import { validationSchema } from './alertSettingsValidation';

interface Props {
  alertSettings: AlertSettingsRow;
  onSave: () => void;
  onCancel: () => void;
}

export function AlertSettingsEditForm({
  alertSettings,
  onSave,
  onCancel,
}: Props) {
  const updateAlertSettings = useUpdateAlertSettings();

  const isInternalAlertManager =
    alertSettings.id?.toString() === '1' && alertSettings.isInternal;

  const initialValues: AlertSettingsFormValues = {
    name: alertSettings.name,
    enabled: alertSettings.enabled,
    notificationChannels: alertSettings.notificationChannels || [],
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
      validateOnChange
      validateOnBlur
    >
      <InnerForm
        isInternalAlertManager={isInternalAlertManager}
        onCancel={onCancel}
      />
    </Formik>
  );

  async function handleSubmit(
    values: AlertSettingsFormValues,
    { setSubmitting }: FormikHelpers<AlertSettingsFormValues>
  ) {
    try {
      const updatedSettings = {
        ...alertSettings,
        ...values,
      };

      await updateAlertSettings.mutateAsync(updatedSettings);
      onSave();
    } catch (error) {
      notifyError('Failure', error, 'Unable to update alert settings');
    } finally {
      setSubmitting(false);
    }
  }
}
